import React from 'react';
import Grid from '@mui/material/Grid2';

import { AttributesEnhancement } from "@dndModels";

import AttributesInput from '@dndComponents/creature/AttributesInput';
import EnhancementModeBox from './EnhancementModeBox';

interface Props {
  value: AttributesEnhancement;
  disabled: boolean;
  onChange: () => void;
}

export default function AttributesEnhancementInput({
  value,
  disabled,
  onChange
}: Props) {
  return (
    <Grid container spacing={0} direction="row">
      <Grid size={12} className="header centered">Attributes</Grid>
      <Grid size={12}>
        <EnhancementModeBox
          name="Mode"
          modes={["Leave","Replace","Add"]}
          value={value.mode}
          disabled={disabled}
          onChange={(changed) => {
            value.mode = changed as AttributesEnhancement["mode"];
            onChange();
          }}
        />
      </Grid>
      <Grid size={12}>
        <AttributesInput
          attributes={value.value}
          disabled={disabled || value.mode === "Leave"}
          onChange={onChange}
        />
      </Grid>
    </Grid>
  );
}
